export default __webpack_public_path__ + "static/media/warning--rabbit-crossing--g1.078f403a.png";